import ListSelect from '~/components/widgets/ListSelect/ListSelect';
import EditorLabel from '../EditorLabel/EditorLabel';
import type { SelectOption } from '~/util';
import './EditorSelect.css';

interface EditorSelectProps<V = unknown> {
  name: string;
  value: V;
  onChange: (val: V) => void;
  options: SelectOption<V>[];
  label: string;
  disabled?: boolean;
  onStateChange?: (val: boolean) => void;
  className?: string;
}

export default function EditorSelect<V = unknown>({
  name,
  value,
  onChange,
  options,
  label,
  disabled,
  onStateChange,
  className
}: EditorSelectProps<V>) {
  return (
    <div className={`EditorRange${className ? ` ${className}` : ''}`}>
      <EditorLabel label={label} htmlFor={name} />
      <ListSelect
        name={name}
        value={value}
        onChange={onChange}
        options={options}
        disabled={disabled}
        onStateChange={onStateChange}
      />
    </div>
  );
}
